import { CallToAction } from 'components/CallToAction'
import React from 'react'
import { heading, section } from 'components/Home/classes'
import {prepareData} from 'utils/googleData'

    export function HomeCTA(props)  {
        const {enable,homeCTATitle,ctas,direction,style,gatsbyImage,textColor='white'}= prepareData({props})
          if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <section dir={direction} className="max-w-screen-2xl mx-auto mt-4 mb-16 md:my-16 px-4 text-center ">
            <div className={style}>
                <h2 className={heading('lg', textColor)}>{homeCTATitle?.title}</h2>
                <h3 className={heading('sm', textColor)}>
                   {homeCTATitle?.subtitle}
                </h3>
                <div className="mt-12 flex flex-col space-y-2 md:space-y-3 items-center justify-center">
                {ctas?.length > 0 && ctas.map(({ text, url,style='' }) => {
                            return (
                    <CallToAction
                        type="custom"
                        width="56"
                        className={`border-2 border-white ${style}`}
                        to={url}
                    >
                        {text}
                    </CallToAction>
                                                )
                                            })}
                </div>
            </div>
        </section>
    )
}
export default HomeCTA
